"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformComponentSymbol = void 0;
const TransformObject_1 = require("./TransformObject");
class TransformComponentSymbol extends TransformObject_1.TransformObject {
    constructor(parent, data) {
        super(parent, {
            ref: data.ref,
            name: data.name,
            pins: data.pins,
            drawings: data.drawings,
            metadata: data.metadata,
            pinSignals: new Map(),
        }, `${parent.deduplicationKey}::${data.ref}`, new Set());
    }
    setPinSignal(pin, signalId) {
        this._sharedData.pinSignals.set(pin, signalId);
    }
    compile() {
        this._sharedData.compiled = {
            result: {
                ref: this._sharedData.ref,
                name: this._sharedData.name,
                pins: this._sharedData.pins,
                drawings: this._sharedData.drawings,
                metadata: this._sharedData.metadata,
            },
            pinSignals: this._sharedData.pinSignals,
        };
        return this._sharedData.compiled;
    }
}
exports.TransformComponentSymbol = TransformComponentSymbol;
//# sourceMappingURL=TransformComponentSymbol.js.map